import React from 'react';
import { FaLightbulb, FaClipboardCheck, FaCode, FaRocket, FaChartLine } from 'react-icons/fa';
import { ProcessStepItem, ProcessContent } from '../types';

export const processContent: ProcessContent = {
  heading: 'Our Process',
  description: 'A proven methodology for developing and deploying successful agentic systems'
};

export const processSteps: ProcessStepItem[] = [
  {
    title: 'Discovery & Assessment',
    description: 'We analyze your current operations, identify opportunities for improvement, and define the objectives for your agentic system.',
    icon: React.createElement(FaLightbulb),
  },
  {
    title: 'Solution Design',
    description: 'Our experts design a tailored solution architecture that addresses your specific requirements and integrates with your existing systems.',
    icon: React.createElement(FaClipboardCheck),
  },
  {
    title: 'Development & Integration',
    description: 'We develop your custom agentic system, rigorously test it in simulated environments, and integrate it with your infrastructure.',
    icon: React.createElement(FaCode),
  },
  {
    title: 'Deployment & Training',
    description: 'We deploy your solution in production, train your team on how to work alongside it, and ensure a smooth transition.',
    icon: React.createElement(FaRocket),
  },
  {
    title: 'Monitoring & Optimization',
    description: 'Our team continuously monitors the performance of your agentic system, making refinements to optimize results and adapt to changing needs.',
    icon: React.createElement(FaChartLine),
  },
];